import { BiSolidErrorCircle } from "react-icons/bi";

const failedMessage = (msg) => ({
    render: msg,
    type: "error",
    icon: <BiSolidErrorCircle />,
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    className : "custom-toast-error"
});

export default failedMessage;